import { useEffect } from "react";
import useEnv from "./use-env";

export const useProductionWarning = () => {
  const { dev } = useEnv();

  // Show a warning to users if they are in production and accessing the console
  useEffect(() => {
    if (!dev) {
      console.log(`
       ++                                            ***  
       +++++++                                   *******  
       ++++++++++                            ***********  
       +++++++++++++++                  ****************  
       ++++++++++++++++++*          ********************  
        ++++++++++++++++++++++   ++*******************    
             ++++++++++++++++++++*    ***********         
                 ++++++++++++++*******    ***             
                   +++++++++++*************               
               +++++++++++++******************            
            ++++++++++++++***********************         
               +++++++++**********************            
                  *+++*********************               
                 +********************    **              
              ++++*****************   ***********         
         ++++++++*************    ********************    
       ++++++++***********         *******************##  
       ++++++*********                  ************####  
       ++++*******                           *****######  
       ++*****                                   #######  
       ***                                           ###  
                                                                                      
      Danger! If you are seeing this you may be looking too hard. If you are having issues please reach out to gavin@govolca.com`);
    }
  }, [dev]);
};
